import React, { useContext, useMemo } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import BlankPage from '../pages/result/@candidate/BlankPage';
import ResultList from '../pages/result/@candidate/ResultList';
import Result from '../pages/result/@candidate/Result';
import RouteKey from './key';
import CoordinatorIndividualResultRelease from '../pages/result/@coordinator/CoordinatorIndividualResultRelease';
import PrivateRoute from '../modules/profile/components/PrivateRoute';
import { Role } from '../models';
import CoordinatorResultReleaseList from '../pages/result/@coordinator/CoordinatorResultReleaseList';
import CoordinatorResult from '../pages/result/@coordinator/CoordinatorResult';

const { error: errorRoute } = RouteKey.child;
const {
  myExaminations,
  myExaminationsResults,
  coordinatorResultRelease,
  coordinatorResultList,
  coordinatorIndividualResult,
  blankPage,
} = RouteKey.result.child;

export const ResultNavigationContext = React.createContext<{
  toList: string;
  toDetail: string;
  toBlankPage: string;
}>({
  toList: '',
  toDetail: '',
  toBlankPage: '',
});

export const useResultNavigation = () => useContext(ResultNavigationContext);

const ResultRoute = () => {
  const { url, path } = useRouteMatch();

  const contextValue = useMemo(
    () => ({
      toList: `${url}/${myExaminations}`,
      toDetail: `${url}/${myExaminations.route}/${myExaminationsResults.route}`,
      toBlankPage: `${url}/${blankPage}`,
    }),
    [url]
  );

  return (
    <ResultNavigationContext.Provider value={contextValue}>
      <Switch>
        <PrivateRoute exact path={path} roles={[Role.candidate]}>
          <Redirect to={`${path}/${myExaminations.route}`} />
        </PrivateRoute>

        <PrivateRoute path={`${path}/${blankPage.route}`} roles={[Role.candidate]}>
          <BlankPage />
        </PrivateRoute>
        <PrivateRoute exact path={`${path}/${myExaminations.route}`} roles={[Role.candidate]}>
          <ResultList />
        </PrivateRoute>
        <PrivateRoute
          exact
          path={`${path}/${myExaminations.route}/${myExaminationsResults.route}`}
          roles={[Role.candidate]}
        >
          <Result />
        </PrivateRoute>

        <PrivateRoute
          path={`${path}/${coordinatorResultList.route}`}
          roles={[Role.coordinator]}
          exact
        >
          <CoordinatorResult />
        </PrivateRoute>
        <PrivateRoute
          path={`${path}/${coordinatorResultList.route}/${coordinatorResultRelease.route}`}
          roles={[Role.coordinator]}
          exact
        >
          <CoordinatorResultReleaseList />
        </PrivateRoute>
        <Route
          path={`${path}/${coordinatorResultList.route}/${coordinatorIndividualResult.route}`}
          exact
        >
          <CoordinatorIndividualResultRelease />
        </Route>

        <Route path="*" exact>
          <Redirect to={`/${errorRoute}`} />
        </Route>
      </Switch>
    </ResultNavigationContext.Provider>
  );
};

export default ResultRoute;
